require("./qf/global_listeners");
require("./snippets/accordion");
require("./snippets/v3-accordion");
require("./snippets/product-quick-view-modal");
//require("./qf/wishlistAsObject");
require("./qf/cart");
require("./qf/loadMore");
require("./qf/ModalController");
require("./qf/babCart");
// NOTE: ./qf/tracking is deliberately NOT bundled here. It is built to
// assets/tracking.min.js and loaded separately so Cookiebot can block it on
// consent decline without taking the side cart / accordions down with it.

window.globalListeners = new GlobalListeners();
window.modalController = new ModalController()
// window.wishlist = new WishlistObjectQf();
window.cart = new CartQf();
window.babCart = new babCart()
